import { defineMessages } from 'react-intl'

export default defineMessages({
  help: {
    defaultMessage: 'Help',
    description: 'help text',
  },
})
